<suite-rfb-collapse title="Utilização" [collapsed]="this.collapsed" (collapsedChange)="this.onCollapsedChange($event)">
  <suite-rfb-alert-messages-with-datetime [onlyFor]="this.scopeId"></suite-rfb-alert-messages-with-datetime>
  <ng-container *ngIf="this.valoresDocumento?.length > 0; else loadingOrError">
    <via-receitas-pagamento [valoresDocumento]="this.valoresDocumento"
                            [exibirLabels]="this.pagamento.possuiMultaJuros"
                            [exibirSaldos]="true">
    </via-receitas-pagamento>
  </ng-container>

  @if (!this.collapsed || this.valoresDocumento != null) {
  <reserva-bloqueio-detalhes [pagamento]="this.pagamento" [collapsed]="false"></reserva-bloqueio-detalhes>
  }
</suite-rfb-collapse>

<ng-template #loadingOrError>
  <div *ngIf="initError; else loading">
  </div>
  <ng-template #loading>
    <loading-animation *ngIf="!stopLoading"></loading-animation>
  </ng-template>
</ng-template>